import DurationInput from './DurationInput';
import { DURATION, SECONDS } from './formatters';

DurationInput.DurationFormat = DURATION;
DurationInput.SecondsFormat = SECONDS;

export default DurationInput;
